import { Helmet } from "react-helmet-async";

const SITE = "https://outdoorbannerframe.com";
const DEFAULT_TITLE = "The Banner Bar | Wind-Resistant Outdoor Banner Frame Kits";
const DEFAULT_DESC = "Patented wind-resistant outdoor banner frame kits for the sign industry. Wholesale dealer pricing, franchise rollouts. Made in USA. Patent 10,410,553.";

/** Per-route SEO meta (title, description, canonical, OG, robots). Crawler-visible on the deployed
 *  site via the platform bot-prerender toggle; the static head in index.html remains the floor. */
export function Seo({ title, description, path, image, noindex = false, jsonLd }) {
  const t = title ? `${title}` : DEFAULT_TITLE;
  const d = description || DEFAULT_DESC;
  const url = path ? `${SITE}${path}` : `${SITE}/`;
  const img = image ? (image.startsWith("http") ? image : `${SITE}${image}`) : `${SITE}/assets/img/hero-home.jpg`;
  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="The Banner Bar" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
